import { render, staticRenderFns } from "./agv-star-rating.vue?vue&type=template&id=341222a8&scoped=true&lang=pug&"
import script from "./agv-star-rating.vue?vue&type=script&lang=js&"
export * from "./agv-star-rating.vue?vue&type=script&lang=js&"
import style0 from "./agv-star-rating.vue?vue&type=style&index=0&id=341222a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341222a8",
  null
  
)

export default component.exports